module.exports = {
  ajaxPrefix: '//m.meitun.com',
  otherAjaxPrefix: '//babytree.citv.cn',
  babytreeAjaxPrefix: '//www.babytree.com',
  babytreeLoginPrefix: '//m.babytree.com',
  IMappKey: 'e853a0c3dcbf69f6c320d60bb072f6e3',
  IMAjaxPrefix: '//mapiweb.babytree.com',
  IMDebug: false,
  localMsglimit: 36
};



// WEBPACK FOOTER //
// ./src/config/prod.config.js